<template>
	<div>
		<div class="tw-text-3xl tw-font-bold">
			{{ $t('integrations.configure-integration') }}
		</div>
		<div class="tw-font-medium tw-text-gray-500">
			{{ $t('integrations.configure-integration-description') }}
		</div>
		<AppForm
			@submit="onSubmit"
			class="tw-mt-3 tw-flex tw-flex-col tw-gap-2"
			v-if="!isDone"
			style="width: 90%"
		>
			<div class="tw-flex tw-flex-col tw-gap-4">
				<AppCheckbox v-model="form.import_product" :disabled="loading">
					<template #label>
						<div class="tw-px-2">
							<div>{{ $t('integrations.import-product') }}</div>
							<div class="tw-text-gray-500">
								{{ $t('integrations.import-product-description') }}
							</div>
						</div>
					</template>
				</AppCheckbox>
				<AppCheckbox v-model="form.update_stock" :disabled="loading">
					<template #label>
						<div class="tw-px-2">
							<div>{{ $t('integrations.update-stock') }}</div>
							<div class="tw-text-gray-500">
								{{ $t('integrations.update-stock-description') }}
							</div>
						</div>
					</template>
				</AppCheckbox>
				<AppCheckbox v-model="form.update_prices" :disabled="loading">
					<template #label>
						<div class="tw-px-2">
							<div>{{ $t('integrations.update-prices') }}</div>
							<div class="tw-text-gray-500">
								{{ $t('integrations.update-prices-description') }}
							</div>
						</div>
					</template>
				</AppCheckbox>
				<AppCheckbox v-model="form.receive_orders_from_odoo" :disabled="loading">
					<template #label>
						<div class="tw-px-2">
							<div>{{ $t('integrations.receive-orders-from-odoo') }}</div>
							<div class="tw-text-gray-500">
								{{ $t('integrations.receive-orders-from-odoo-description') }}
							</div>
						</div>
					</template>
				</AppCheckbox>
				<AppCheckbox v-model="form.create_orders_on_odoo" :disabled="loading">
					<template #label>
						<div class="tw-px-2">
							<div>{{ $t('integrations.create-orders-on-odoo') }}</div>
							<div class="tw-text-gray-500">
								{{ $t('integrations.create-orders-on-odoo-description') }}
							</div>
						</div>
					</template>
				</AppCheckbox>

				<div v-if="form.create_orders_on_odoo" class="tw-mx-12 tw-flex tw-flex-col tw-gap-4">
					<AppInput
						v-model="form.warehouse_id"
						:label="$t('integrations.warehouse-id')"
						:rules="['required']"
						:disabled="loading"
						class="tw-w-1/2"
					/>

					<div class="tw-flex tw-flex-col tw-gap-4">
						<AppRadio
							v-model="form.order_customer"
							value="PER_SALES_CHANNEL"
							:label="$t('integrations.per-sales-channel')"
							:disabled="loading"
						/>
						<AppRadio
							v-model="form.order_customer"
							value="PER_CUSTOMER"
							:label="$t('integrations.per-customer')"
							:disabled="loading"
						/>
					</div>
				</div>
			</div>

			<div class="tw-mt-5">
				<AppButton
					:label="$t('integrations.complete-setup')"
					size="xl"
					endIcon="check"
					class="tw-rounded-full !tw-px-6"
					type="submit"
					:disabled="loading"
					:loading="loading"
				/>
			</div>
		</AppForm>
	</div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useLinkMarketplaceStore } from '../../../../stores/link-marketplace';
import { Marketplace } from '../../../../entities/marketplace';
import { marketplaceStepStatusEnum } from '../../helper';
import { useRouter } from 'vue-router';

const linkMarketplaceStore = useLinkMarketplaceStore();

const router = useRouter();

const form = ref({
	import_product: false,
	update_stock: false,
	update_prices: false,
	receive_orders_from_odoo: false,
	create_orders_on_odoo: false,
	warehouse_id: '',
	order_customer: 'PER_CUSTOMER',
});

const formLoading = ref(false);

const loading = computed(
	() =>
		formLoading.value ||
		linkMarketplaceStore.currentStepData.status === marketplaceStepStatusEnum.InProgress,
);
const isDone = computed(
	() => linkMarketplaceStore.currentStepData.status === marketplaceStepStatusEnum.Complete,
);

const onSubmit = async () => {
	formLoading.value = true;
	try {
		const success = await Marketplace.setOdooConfig(form.value);
		if (success) {
			await Marketplace.finishWizardStep(linkMarketplaceStore.currentStepData.id);
			router.push('/v2/integrations/marketplaces');
		}
	} finally {
		formLoading.value = false;
	}
};
</script>

<style lang="scss" scoped></style>
